import { createContext, ReactNode, useContext } from "react";

import { useFilterBirthdayReward } from "./filter-birthday-reward.hook";

const FilterBirthdayRewardContext = createContext(
  {} as ReturnType<typeof useFilterBirthdayReward>
);
export function useFilterBirthdayRewardContext() {
  return useContext(FilterBirthdayRewardContext);
}

interface FilterBirthdayRewardProviderProps {
  children: ReactNode;
}
export function FilterBirthdayRewardProvider({
  children,
}: FilterBirthdayRewardProviderProps) {
  return (
    <FilterBirthdayRewardContext.Provider value={useFilterBirthdayReward()}>
      {children}
    </FilterBirthdayRewardContext.Provider>
  );
}